import React, { useContext } from 'react'
// components
import { Button, BUTTON_LAYOUTS } from 'components/UI'
// views
import { Wrapper, InnerWrapper, Container, BackgroundImage, BUTTON_STYLE } from './view'
// context
import { SubPlanStepperBLContext } from 'containers/SubPlan/layers/BL/Stepper'

const FinalStep = () => {
  const { handleSubmitClick } = useContext(SubPlanStepperBLContext)

  return (
    <Wrapper>
      <InnerWrapper>
        <Container>
          <p>Great Work!</p>
          <div>
            By creating this sub plan you are 1 step closer to linking and aligning our organisation’s strategies and
            activities
          </div>
          <Button layout={BUTTON_LAYOUTS.PURPLE} onClick={handleSubmitClick} style={BUTTON_STYLE}>
            View plan
          </Button>
        </Container>
      </InnerWrapper>
      <BackgroundImage />
    </Wrapper>
  )
}

export default FinalStep
